import React from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import {
    PURCHASES_TAB,
    PURCHASES_SUPPLIERS_TAB,
    PURCHASES_DOCS_TAB,
    PURCHASES_ARCHIVE_TAB,
    PURCHASES_COUNTERPARTIES_TAB,
} from '../constant';
import PurchasesSupplierOrdersTab from './PurchasesSupplierOrdersTab';
import PurchasesDocsTab from './PurchasesDocsTab';
import PurchasesArchiveTab from './PurchasesArchiveTab';
import PurchasesCounterpartiesTab from './PurchasesCounterpartiesTab';

const TAB_CONFIG = [
    { key: PURCHASES_SUPPLIERS_TAB, title: 'Заказы поставщиков', path: 'supplier-orders' },
    { key: PURCHASES_DOCS_TAB, title: 'Документы закупки', path: 'purchase-docs' },
    { key: PURCHASES_ARCHIVE_TAB, title: 'Архив', path: 'purchase-archive' },
    { key: PURCHASES_COUNTERPARTIES_TAB, title: 'Контрагенты', path: 'counterparties' },
];

const PurchasesTab = ({ isCollapsed }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const activeKey = (() => {
        if (location.pathname.includes(PURCHASES_COUNTERPARTIES_TAB)) return PURCHASES_COUNTERPARTIES_TAB;
        if (location.pathname.includes(PURCHASES_ARCHIVE_TAB)) return PURCHASES_ARCHIVE_TAB;
        if (location.pathname.includes(PURCHASES_DOCS_TAB)) return PURCHASES_DOCS_TAB;
        return PURCHASES_SUPPLIERS_TAB;
    })();

    const orderJumpId = new URLSearchParams(location.search).get('orderId');
    const showOrderJump = Boolean(orderJumpId) && location.pathname.includes('/supplier-orders');

    const handleChange = (path) => {
        navigate(`/purchases/${path}`);
    };

    return (
        <div className={`sales${showOrderJump ? ' sales--order-jump' : ''}`}>
            {showOrderJump ? (
                <div className="sales-order-jump" aria-hidden="true">
                    <div className="sales-order-jump__spinner" />
                </div>
            ) : null}
            <div className="sales-tabs__list">
                {TAB_CONFIG.map((tab) => {
                    const isActive = activeKey === tab.key;
                    return (
                        <button
                            key={tab.key}
                            className={`sales-tabs__button${isActive ? ' sales-tabs__button--active' : ''}`}
                            onClick={() => handleChange(tab.path)}
                        >
                            {tab.title}
                        </button>
                    );
                })}
            </div>
            <Routes>
                <Route exact path="supplier-orders" element={<PurchasesSupplierOrdersTab isCollapsed={isCollapsed} />} />
                <Route exact path="purchase-docs" element={<PurchasesDocsTab isCollapsed={isCollapsed} />} />
                <Route exact path="purchase-archive" element={<PurchasesArchiveTab isCollapsed={isCollapsed} />} />
                <Route exact path="counterparties" element={<PurchasesCounterpartiesTab isCollapsed={isCollapsed} />} />
                <Route path="*" element={<Navigate to="supplier-orders" replace />} />
            </Routes>
        </div>
    );
};

export default PurchasesTab;
